<nav class="navbar navbar-expand navbar-light topbar mb-4 static-top fixed-top">
  <button id="sidebarToggleTop" type="button" class="btn btn-link rounded-circle mr-3">
    <i class="fa fa-bars mainFontColor"></i>
  </button>

  <!-- <div *ngIf="showPlansButton$ | async" class="plan-expire">
    <ng-container>
      <a (click)="attPlan()">
        <button class="text-center btn btn-plan">
          <span class="expire">
            {{ voucher_expires_at }} dias para expirar!</span>
          <span class="att-plan">Clique RENOVAR</span>
        </button>
      </a>
    </ng-container>
  </div> -->

  <!-- <div class="title" [hidden]="!projectOpen">
    <ng-container>
      <h6 class="project-name">{{ titleProject }}</h6>
      <span class="author">{{ author }}</span>
    </ng-container>
  </div> -->

  <!-- <div class="title" *ngIf="showPlansButton$ | async">
    <ng-container>
      <a class="plan" (click)="attPlan()">
        <h6 class="project-name mb-0">{{ voucher_expires_at }} dias para expirar!</h6>
        <span class="author">Clique para RENOVAR</span>
      </a>
    </ng-container>
  </div> -->

  <ul class="navbar-nav ml-auto">

    <li class="title nav-item d-lg-flex d-none align-items-center">
      <a class="plan" (click)="attPlan()">
        <h6 class="project-name mb-0">{{ voucher_expires_at }} dias para expirar!</h6>
        <span *ngIf="voucher_expires_at == 0" class="author" (click)="attPlan()">Clique para RENOVAR</span>
        <span *ngIf="voucher_expires_at > 0" class="author" (click)="attPlan()">{{ getText() }}</span>
      </a>
    </li>
    
    <li class="title nav-item d-lg-flex d-none align-items-center">
      <div [hidden]="!projectOpen">
        <ng-container>
          <h6 class="project-name" [title]="titleProject">{{ titleProject }}</h6> <!--[title]="titleProject-->
          <span class="author">{{ author }}</span>
        </ng-container>
      </div>
    </li>


    <li class="nav-item dropdown no-arrow d-sm-none">
      <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        <i class="fas fa-search fa-fw"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
      </div>
    </li>

    <li class="nav-item no-arrow mx-1" *ngIf="showFileDownloadButton">
      <span *ngIf="editorLabelsStatus && setLabelVisible" class="badge badge-pill badge-{{
          editorLabelsStatus.color
        }} badge-into-d-flex mr-2 mt-4">
        {{ editorLabelsStatus.text }}
      </span>
    </li>

    <li class="nav-item no-arrow mx-1" *ngIf="showFileDownloadButton && spinnerProgress > 0">
      <a class="nav-link" href="#" role="button" style="width: max-content; color: goldenrod">
        {{ spinnerProgress }} %
      </a>
    </li>

    <li class="nav-item no-arrow mx-1" *ngIf="showFileDownloadButton">
      <a class="nav-link btn-download" role="button" (click)="downloadPdf()" title="Baixar PDF do documento"
        aria-label="Baixar PDF do documento" style="font-size: 20px">
        <i class="fas fa-file-download"></i>
      </a>
    </li>

    <li class="nav-item dropdown no-arrow mx-1" [hidden]="!showNotificationsDropdown()">
      <a class="nav-link dropdown-toggle" id="alertsDropdown" href="#" role="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" (click)="getComments(dropDownMenu)" title="Comentários do Projeto"
        aria-label="Comentários do Projeto" style="font-size: 20px">
        <i class="fas fa-bell fa-fw"></i>
        <span class="badge badge-danger badge-counter">{{
          countComments
          }}</span>
      </a>
      <div #dropDownMenu class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
        aria-labelledby="alertsDropdown">
        <h6 class="dropdown-header">Comentários</h6>
        <!-- <a class="dropdown-item d-flex align-items-center" [href]="comment.api_route" *ngFor="let comment of comments"> -->
          <a class="dropdown-item d-flex align-items-center" *ngFor="let comment of comments">
          <div>
            <div class="small text-gray-900 mainFontColor">
              Pelo {{ getMessageAuthor(comment?.user) }}
              {{ comment?.user.name }}
            </div>
            {{ comment.message }}
            <div class="small text-gray-700">
              {{ comment.created_at | date : "dd/MM/yyyy HH:mm" }}
            </div>
          </div>
        </a>
      </div>
    </li>

    <li class="nav-item dropdown no-arrow mx-1" [hidden]="!this.projectOpen">
      <a style="color: #929292" class="nav-link" href="#" role="button" title="Porcentagem de Conclusão"
        aria-label="Porcentagem de Conclusão">
        <app-circular-progress-bar [percentage]="percentage"></app-circular-progress-bar>
      </a>
    </li>

    <div class="topbar-divider d-none d-sm-block"></div>

    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        <span class="mr-2 d-none d-lg-inline small mainFontColor"><strong>{{ profile?.name }}</strong></span>
        <img class="img-profile rounded-circle" [src]="
            profile?.url_image ? profile?.url_image : 'assets/img/profile.png'
          " />
        <div class="p-1">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </div>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
        <a class="dropdown-item" [routerLink]="['/public/profile']">
          <i class="fas fa-user fa-sm fa-fw mr-2"></i>
          Perfil
        </a>

        <a class="dropdown-item" (click)="attPlan()">
          <i class="fa fa-star mr-2" aria-hidden="true"></i>
          Minhas Assinaturas
        </a>
        
        <div class="dropdown-divider"></div>

        <a class="dropdown-item" href="/" (click)="logout()" data-toggle="modal" data-target="#logoutModal">
          <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
          Sair
        </a>
      </div>
    </li>
  </ul>
</nav>